"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompanyPlantPrefix = exports.Company = void 0;
var Company;

(function (Company) {
  Company["RYERSON"] = "ryerson";
  Company["SOUTHERN_TOOL_STEEL"] = "southernToolSteel";
  Company["CENTRAL_STEEL"] = "centralSteel";
})(Company || (exports.Company = Company = {}));

var CompanyPlantPrefix;

(function (CompanyPlantPrefix) {
  CompanyPlantPrefix["CentralSteel"] = "109";
})(CompanyPlantPrefix || (exports.CompanyPlantPrefix = CompanyPlantPrefix = {}));